module.exports = __webpack_public_path__ + "media/images/Pin-7a1e9d44.png";